var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBroadbandCircleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.506,
    height: 49.506,
    viewBox: "0 0 49.506 49.506",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_136",
    "data-name": "Component 136",
    transform: "translate(0.753 0.753)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_106",
    "data-name": "Ellipse 106",
    cx: 24,
    cy: 24,
    r: 24,
    fill: "none",
    stroke: "#e62a32",
    strokeMiterlimit: 10,
    strokeWidth: 1.506
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3917",
    "data-name": "Group 3917",
    transform: "translate(-443.875 -304.701)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2293",
    "data-name": "Path 2293",
    d: "M472.742,331.9a6.227,6.227,0,0,0-4.891-2.209A6.1,6.1,0,0,0,463,331.9",
    fill: "none",
    stroke: "#e62a32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.506
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2294",
    "data-name": "Path 2294",
    d: "M476.288,328.263a12.221,12.221,0,0,0-16.865.057",
    fill: "none",
    stroke: "#e62a32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.506
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2295",
    "data-name": "Path 2295",
    d: "M479.638,324.913a17.838,17.838,0,0,0-23.525-.019",
    fill: "none",
    stroke: "#e62a32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.506
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_107",
    "data-name": "Ellipse 107",
    cx: 1.21,
    cy: 1.21,
    r: 1.21,
    transform: "translate(466.662 334.508)",
    fill: "none",
    stroke: "#e62a32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.506
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2296",
    "data-name": "Path 2296",
    d: "M467.872,335.055",
    fill: "none",
    stroke: "#e62a32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.506
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadbandCircleIcon);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OS41MDYiIGhlaWdodD0iNDkuNTA2IiB2aWV3Qm94PSIwIDAgNDkuNTA2IDQ5LjUwNiI+CiAgPGcgaWQ9IkNvbXBvbmVudF8xMzYiIGRhdGEtbmFtZT0iQ29tcG9uZW50IDEzNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC43NTMgMC43NTMpIj4KICAgIDxjaXJjbGUgaWQ9IkVsbGlwc2VfMTA2IiBkYXRhLW5hbWU9IkVsbGlwc2UgMTA2IiBjeD0iMjQiIGN5PSIyNCIgcj0iMjQiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2U2MmEzMiIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjEuNTA2Ii8+CiAgICA8ZyBpZD0iR3JvdXBfMzkxNyIgZGF0YS1uYW1lPSJHcm91cCAzOTE3IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDQzLjg3NSAtMzA0LjcwMSkiPgogICAgICA8cGF0aCBpZD0iUGF0aF8yMjkzIiBkYXRhLW5hbWU9IlBhdGggMjI5MyIgZD0iTTQ3Mi43NDIsMzMxLjlhNi4yMjcsNi4yMjcsMCwwLDAtNC44OTEtMi4yMDlBNi4xLDYuMSwwLDAsMCw0NjMsMzMxLjkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2U2MmEzMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjEuNTA2Ii8+CiAgICAgIDxwYXRoIGlkPSJQYXRoXzIyOTQiIGRhdGEtbmFtZT0iUGF0aCAyMjk0IiBkPSJNNDc2LjI4OCwzMjguMjYzYTEyLjIyMSwxMi4yMjEsMCwwLDAtMTYuODY1LjA1NyIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZTYyYTMyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41MDYiLz4KICAgICAgPHBhdGggaWQ9IlBhdGhfMjI5NSIgZGF0YS1uYW1lPSJQYXRoIDIyOTUiIGQ9Ik00NzkuNjM4LDMyNC45MTNhMTcuODM4LDE3LjgzOCwwLDAsMC0yMy41MjUtLjAxOSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZTYyYTMyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41MDYiLz4KICAgICAgPGNpcmNsZSBpZD0iRWxsaXBzZV8xMDciIGRhdGEtbmFtZT0iRWxsaXBzZSAxMDciIGN4PSIxLjIxIiBjeT0iMS4yMSIgcj0iMS4yMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDY2LjY2MiAzMzQuNTA4KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZTYyYTMyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41MDYiLz4KICAgICAgPHBhdGggaWQ9IlBhdGhfMjI5NiIgZGF0YS1uYW1lPSJQYXRoIDIyOTYiIGQ9Ik00NjcuODcyLDMzNS4wNTUiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2U2MmEzMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjEuNTA2Ii8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };